import { useUserStore } from "@/store/user";
import { usePopupStore } from "@/store/popup";
import { EXISTING_POPUPS } from "@/utils/variables";
import { getPopup } from "@/utils/storage";
import popupConfig from "@/configs/popup-config";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";

export default async ({ from, to, pinia }: MiddlewareInterface) => {
  let hash = from.hash.substring(1) || to.hash.substring(1) || "";
  hash = hash.split("?")[0];

  if (!hash || !EXISTING_POPUPS.includes(hash)) {
    return;
  }

  let toHash = to.hash.substring(1) || "";
  toHash = toHash.split("?")[0];

  const isLoggedIn = useUserStore(pinia).isLoggedIn;

  if (toHash && EXISTING_POPUPS.includes(toHash) && ((!isLoggedIn && popupConfig[toHash].requiresAuth) || !popupConfig[toHash].initOnHash)) {
    history.pushState("", document.title, window.location.pathname);
    return;
  }

  const popupStore = usePopupStore(pinia);

  if (!from.hash) {
    const popupData = getPopup(hash)?.data ?? null;
    popupStore.show(hash, popupData);
  }

  if (!to.hash) {
    popupStore.hide(hash);
  }
};
